import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { ServiceObjectTreeNodeComponent } from "app/client/components/serviceObject/tree-node/serviceObject-tree-node.component";

@NgModule({
  declarations: [
    ServiceObjectTreeNodeComponent
  ],
  exports: [
    ServiceObjectTreeNodeComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class ServiceObjectTreeNodeModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/components/serviceObject/tree-node/serviceObject-tree-node.module.ts